<template>
  <Teleport defer to="#sb-etiket">
    <slot name="etiket" />
    <Tag v-if="pasif !== null" :severity="pasif ? 'danger' : 'success'" :value="pasif ? 'Pasif' : 'Aktif'" />
    <Tag v-if="durumMetni" severity="info" :value="durumMetni" />
  </Teleport>
  <!-- MD-2: dar ekranda bağlam (şube seçici) başlığın altında ince ikinci satır -->
  <Teleport v-if="darEkran && $slots.baglam" defer to="#sb-baglam">
    <slot name="baglam" />
  </Teleport>
  <Teleport defer to="#sb-eylem">
    <slot v-if="!darEkran" name="baglam" />
    <template v-if="darEkran">
      <Button
        v-if="ikincilVarMi"
        type="button"
        icon="pi pi-ellipsis-v"
        text
        rounded
        severity="secondary"
        aria-label="Diğer eylemler"
        @click="togglePopover"
      />
      <Popover ref="popoverRef">
        <div class="flex flex-col items-stretch gap-1 w-48 sb-ikincil-menu">
          <slot />
        </div>
      </Popover>
    </template>
    <span v-else class="sb-ikincil contents"><slot /></span>
    <template v-if="!darEkran">
      <slot name="birincil" />
      <slot name="yeni" />
    </template>
  </Teleport>
  <!-- MD-2 (MD-K1/K2): dar ekranda «Yeni X» sağ altta yuvarlak düğme (FAB), öbür ana eylemler
       ekranın altında sabit eylem çubuğu. Yeni Sürüm şeridi görünürken ikisi de onun üstüne çıkar;
       Sparqon paneli (z 1000, dar ekranda tam ekran) açıkken üstlerini örter. -->
  <Teleport v-if="darEkran" to="body">
    <div v-if="$slots.birincil" :class="['sb-altcubuk', { 'sb-yukari': surum.goster }]">
      <slot name="birincil" />
    </div>
    <YeniDugme v-if="$slots.yeni" :cubuklu="!!$slots.birincil">
      <slot name="yeni" />
    </YeniDugme>
  </Teleport>
</template>

<script>
import { uiState } from "@/services/uiState";
import { darEkranDurum } from "@/services/darEkran";
import { yeniSurumState } from "@/services/yeniSurum";
import YeniDugme from "./YeniDugme.vue";

// Sayfa şablonundaki eylem/etiket slot'larını layout başlığına (SayfaBasligiAlani.vue,
// #sb-etiket / #sb-eylem) ışınlar; yerinde hiçbir şey çizmez. Vue 3.5 Teleport `defer`
// olmadan ilk yüklemede hedef DOM'a henüz eklenmediği için Teleport çalışmaz.
// bkz. Dokumanlar/Arayuz/SAYFA-BASLIGI-PLANI.md §3.3.
let aktifOrnekSayisi = 0;

export default {
  name: "SayfaBasligi",
  components: { YeniDugme },
  props: {
    baslik: { type: String, default: null },
    pasif: { type: Boolean, default: null },
    durumMetni: { type: String, default: null },
    geriYedek: { type: [String, Object], default: null },
  },
  data() {
    return {
      ekran: darEkranDurum,
      surum: yeniSurumState,
    };
  },
  computed: {
    darEkran() {
      return this.ekran.dar;
    },
    ikincilVarMi() {
      return !!(this.$slots.default && this.$slots.default().length > 0);
    },
  },
  watch: {
    baslik: { immediate: true, handler(v) { uiState.sayfaBasligi.baslik = v; } },
    pasif: { immediate: true, handler(v) { uiState.sayfaBasligi.pasif = v; } },
    durumMetni: { immediate: true, handler(v) { uiState.sayfaBasligi.durumMetni = v; } },
    geriYedek: { immediate: true, handler(v) { uiState.sayfaBasligi.geriYedek = v; } },
  },
  mounted() {
    aktifOrnekSayisi++;
    if (aktifOrnekSayisi > 1 && process.env.NODE_ENV !== "production") {
      console.warn("[SayfaBasligi] Aynı anda birden fazla SayfaBasligi mount edildi — Teleport hedefi çakışır.");
    }
  },
  beforeUnmount() {
    aktifOrnekSayisi--;
    uiState.sayfaBasligi.baslik = null;
    uiState.sayfaBasligi.pasif = null;
    uiState.sayfaBasligi.durumMetni = null;
    uiState.sayfaBasligi.geriYedek = null;
  },
  methods: {
    togglePopover(event) {
      this.$refs.popoverRef.toggle(event);
    },
  },
};
</script>

<style scoped>
/* Popover PrimeVue Button'ları varsayılan olarak ortalar; SB §3.3 "tam genişlik, sola hizalı" ister. */
.sb-ikincil-menu :deep(.p-button) {
  justify-content: flex-start;
}

/* MD-2 alt eylem çubuğu: en çok 2 eylem, tam genişlikte eşit bölünür. Son satırı örtmemesi için
   AdminLayout sayfanın arkasına boşluk bloğu koyar (MDK-5, .sayfa-alt-bosluk). */
.sb-altcubuk {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 900;
  display: flex;
  gap: 8px;
  padding: 8px 16px calc(8px + env(safe-area-inset-bottom, 0px));
  background: #ffffff;
  border-top: 1px solid #e5e7eb;
  box-shadow: 0 -2px 8px rgb(0 0 0 / 0.06);
}
.sb-altcubuk > :deep(*) {
  flex: 1 1 0;
  min-width: 0;
  justify-content: center;
}
.my-app-dark .sb-altcubuk {
  background: #111827;
  border-top-color: #374151;
}

.sb-altcubuk.sb-yukari {
  bottom: calc(96px + env(safe-area-inset-bottom, 0px));
}
</style>

<style>
/* MD-2: v-if'li eylemlerin hepsi gizliyse alt çubuk da görünmez. Scoped değil: scoped derleyici
   :has() içindeki seçiciye data-v ekleyip slot çocuklarını eşleşmez yapabilir. */
.sb-altcubuk:not(:has(> *)) {
  display: none !important;
}
</style>
